import { render, staticRenderFns } from "./RegisterPanel.vue?vue&type=template&id=834bb18c&"
import script from "./RegisterPanel.vue?vue&type=script&lang=js&"
export * from "./RegisterPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports